module.exports = __webpack_public_path__ + "img/app-mode.c9438cf5.svg";